import { Router, useMatch } from "@solidjs/router";
import { FileRoutes } from "@solidjs/start/router";
import { type ParentComponent, Show, Suspense, Switch } from "solid-js";
import "./app.css";
import { MinimalLayoutProvider } from "~/components/layouts/minimal";
import { I18nProvider } from "~/i18n/context";
import { ArtifactStoreProvider } from "~/stores/ArtifactStore";
import { WireProvider } from "~/wire";
import { ChatStreamPage } from "./page/chat/ChatStreamPage";
import { FeatureBaseMessengerInit } from "./third-party/featurebase";

// App constructs the application and provides the main entry point for the
// application. It is responsible for initializing and rendering
// the application.
export default function App() {
  return (
    <Suspense>
      <Router
        root={(props) => {
          return (
            <>
              <I18nProvider>
                <WireProvider>
                  <ArtifactStoreProvider>
                    <MinimalLayoutProvider>
                      <InterceptChatPages>{props.children}</InterceptChatPages>
                    </MinimalLayoutProvider>
                    <FeatureBaseMessengerInit />
                  </ArtifactStoreProvider>
                </WireProvider>
              </I18nProvider>
            </>
          );
        }}
      >
        <FileRoutes />
      </Router>
    </Suspense>
  );
}

/**
 * Needed so that the chat stream page doesn't get re-mounted when navigating between home and chats
 */
export const InterceptChatPages: ParentComponent = (props) => {
  const matchRoot = useMatch(() => "/");
  const matchChat = useMatch(() => "/chat/:chatId");
  return (
    <Show when={matchChat() || matchRoot()} fallback={props.children}>
      <ChatStreamPage />
    </Show>
  );
};
